<app-top-navigation></app-top-navigation>

<section class="home-bg relative text-left">
    <div class="container">
        <div class="centered-element">
           <div class="row">
            <div class="medium-12 columns">
                <div class="mega-text margin-bottom-05 uppercase gotham">
                Mapping Service
                </div>
                <div class="huge-text gotham thin-font">
              Solusi penuh untuk kebutuhan pemetaan dengan tim profesional 
                </div>
            </div>
           </div>
        </div>
    </div>
</section>

<div class="padding-center gotham black-color">
    <div class="row">
        <div class="medium-5 columns">
           <div class="padding-middle">
            <div class="mega-text">
                All In Solution
              </div>
              <div class="large-text thin-font">
                Kami berkomitmen untuk menyediakan semua kebutuhan konsumen kami. Mulai dari pembelian produk, kebutuhan training, dan juga jasa pemetaan untuk semua sektor bisnis
              </div>
           </div>
        </div>
        <div class="medium-7 columns">
            <img class="cover-image" src="/assets/image/gallery4.jpeg" alt="">
        </div>
    </div>
</div>

<div class="padding-center gotham black-color">
    <div class="row">

        <div class="medium-7 columns">
            <img class="cover-image" src="/assets/image/gallery14.jpeg" alt="">
        </div>
        <div class="medium-5 columns">
            <div class="padding-middle">
                <div class="mega-text">
                   Profesional Team
                  </div>
                  <div class="large-text thin-font">
                   Kualitas dan keselamatan adalah prioritas kami. Semua solusi dan jasa pemetaan ditangani oleh tim profesional dan sudah terlatih dengan standar sektor industri
                  </div>
               </div>
        </div>
    </div>
</div>


<div class="padding-center gotham black-color">
    <div class="row">
        <div class="medium-6 columns">
            <div class="padding-middle">
                <div class="mega-text">
                  After Sales
                  </div>
                  <div class="large-text thin-font">
                    Kami sudah membantu banyak sektor industri untuk jasa pemetaan. Komitmen kami untuk selalu membantu dan memberikan layanan kedepan adalah prioritas utama kami
                </div>
               </div>
        </div>
        <div class="medium-6 columns">
            <img class="cover-image" src="/assets/image/gallery15.jpeg" alt="">
        </div>
    </div>
</div>
<div class="padding-center gotham white" style="background: #eee;">
   <div class="padding-middle">
    <div class="row">
        <div class="medium-4 columns">
            <div class="padding-middle">
                <div class="mega-text black-color">
                 Our Client
                  </div>
                 
               </div>
        </div>
        <div class="medium-8 columns">

            <div class="row medium-up-4 margin-bottom-3 small-up-4">

                <div *ngFor="let item of logo" class="columns margin-bottom-1">
                    <img class="logo" width="100" height="100" [src]="item.url" alt="">
                </div>
             

            </div>

        </div>
    </div>
   </div>
</div>



<app-section-footer></app-section-footer>